import styled from "styled-components";

import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import breakpoints from "core/breakpoints";

export const FooterStyled = styled.footer`
    display: flex;
    justify-content: flex-end;
    align-items: center;

    height: ${convertPxToRem({ px: 43 })};

    border-top: solid 1px ${colors.accent.darkMode.suenosBuenos};
    padding-top: ${convertPxToRem({ px: 16 })};
    margin-top: ${convertPxToRem({ px: 16 })};
`;

export const SocialContainerStyled = styled.div`
    flex: 0 0 ${convertPxToRem({ px: 62 })};
`;

export const BackLinkStyled = styled.div`
    flex: 1;

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        display: none;
    }
`;
